
<template>
    <BaseView contentClass="bg-white">
        <template v-slot:top>
            <TitleBar
                :title="$t('Report')"
                @left-click="$router.go(-1)"
                @right-click="downloadPdf"
            >
                <template v-slot:leftIcon>
                    <CloseIcon />
                </template>
                <template v-slot:rightIcon>
                    <DownloadIcon />
                </template>
            </TitleBar>
        </template>

        <InspectionReport
            :resource="inspection"
        />

    </BaseView>
</template>

<script>
import inspectionService from '@mobile/services/inspection';
import Loader from '@mobile/components/Loader';
import BaseView from '@mobile/components/BaseView.vue';
import CloseIcon from '@mobile/components/Icons/CloseIcon.vue';
import DownloadIcon from '@mobile/components/Icons/DownloadIcon.vue';
import TitleBar from '@/components/TitleBar.vue';
import InspectionReport from '@/components/InspectionReport/InspectionReport.vue';
import { eventBus } from '@/eventBus';

export default {

    components: {
        InspectionReport, Loader, BaseView, TitleBar, CloseIcon, DownloadIcon,
    },

    props: {
        inspectionId: {
            required: true,
        },
    },

    data: () => ({
        inspection: null,
        pdfUrl: null,
    }),
    created() {
        Promise.all([
            inspectionService
                .get(this.inspectionId, true)
                .then((inspection) => {
                    this.inspection = inspection;
                }),
            inspectionService
                .getPDFURL(this.inspectionId)
                .then((url) => {
                    this.pdfUrl = url;
                }),
        ]).then(
            () => eventBus.$emit('loaded'),
            (error) => eventBus.$emit('client-error', error),
        );
    },


    methods: {
        downloadPdf() {
            location.href = this.pdfUrl;
        },
    },
};
</script>
